import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'

import { IPartner } from 'clickNgo/entities/partner/models'
import {
  EPartnersCrud,
  ICrudOptions,
  onboardingPartnerApi,
  TCreatePartnerResponse,
  TOptionalFieldConfig,
  TUpdatePartnerResponse,
} from 'onboarding/api/OnboardingPartnerApi'

class PartnerService {
  public fetchById(id: number, crudKey: EPartnersCrud): Promise<IFormPartners | null> {
    return onboardingPartnerApi.fetchById(id, { crudKey })
  }

  public fetchChangeRequestByPartnerId(
    partnerId: string,
    options: ICrudOptions
  ): Promise<IFormPartners | null> {
    return onboardingPartnerApi.fetchChangeRequestByPartnerId(partnerId, options)
  }

  public fetchOneByPartnerId(
    partnerId: string,
    options: Pick<ICrudOptions, 'crudKey' | 'needCached'>
  ): Promise<IFormPartners | null> {
    return onboardingPartnerApi.fetchOneByPartnerId(partnerId, options)
  }

  public fetchPartnerOrChangeRequest(
    partnerId: string,
    crudKey: EPartnersCrud
  ): Promise<IFormPartners | null> {
    return onboardingPartnerApi.fetchPartnerOrChangeRequest(partnerId, {
      crudKey,
    })
  }

  public fetchLastPartnerOrChangeRequest(
    partnerId: string,
    crudKey: EPartnersCrud
  ): Promise<IFormPartners | null> {
    return onboardingPartnerApi.fetchPartnerOrChangeRequest(partnerId, {
      crudKey,
      sort: { field: 'EntryId', dir: 'desc' },
    })
  }

  public fetchPartnerMatchedExclusionList(partnerId: string) {
    return onboardingPartnerApi.fetchPartnerMatchedExclusionList(partnerId)
  }

  public async create(partner: IPartner): Promise<TCreatePartnerResponse> {
    return onboardingPartnerApi.create(partner)
  }

  public async update(partner: IPartner): Promise<TUpdatePartnerResponse> {
    return onboardingPartnerApi.update(partner)
  }

  public checkAnyPartnerExistsWithTaxId(taxId: string) {
    return onboardingPartnerApi.checkAnyPartnerExistsWithTaxId(taxId)
  }

  public fetchOptionalFieldConfig(): Promise<TOptionalFieldConfig> {
    return onboardingPartnerApi.fetchOptionalFieldConfig()
  }

  public async exportAll(accessToken: string): Promise<File> {
    return onboardingPartnerApi.exportAll(accessToken)
  }
}

export const partnerService = new PartnerService()
